var _defs, _style, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 17",
    width: 19,
    height: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 17,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAARCAMAAAAIRmf1AAAAAXNSR0IB2cksfwAAASNQTFRFAj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Ml6KCQAAAGF0Uk5TABeg8vG9OM3/6Pb9BF/vrSzG+hBmmZyzfgO131MJyInFVUVHSCP0Ke3WFeccqJgrICEiBy3d5dri49zb5CgupODhULBK1zAekXcKwm2EoV1o0QhvPv4Oy7vYfBhNS9LsqV3UCRsAAADUSURBVHicZc/XVsJAFIXhQxF2AEtClSIqJJTQlSigKMWGUiz0+v5PATOwWGbxX+313cwZIl0Go8l8pCeLFYLN/l8cxyc4PRMlIqfLbeR5vLD7zmljBj/2BYJEoQuJwri8uo6wohGZthZQYrpnmMUTyQNT1dSBpZHJ5vKsgnyzs9sitLv7UrlS0h78j1uj6hOgqcBzUUCtTg5mRA00Uy/Ka+jtHdJH65PbF9rUQXezegrEOP+vRfr++UWGzT8r+hU2BkOMxpjwU6azepWP+WIprJz7E9ee/hqXGCfyHwAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoIcon);
export default __webpack_public_path__ + "static/media/promoIcon.4eb099c5763929def6232136877b24be.svg";
export { ForwardRef as ReactComponent };